
    @if(formGroup.get('orderDetail') !== null){

        <form [formGroup]="getFormGroup()">
            <div class="p-2 ">
                <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
                    Order Details
                </div>
                <div class="row mb-1 m-2">
                    <label class="col-4 mt-2 mogo-label text-start mogo-bold"  for="customer-reference-input">Customer Reference:</label>
                    <div class="col-8">
                        <input id="customer-reference-input" type="text" class="form-control required" formControlName="customerReference"  placeholder="Customer Reference" />
                    </div>

                </div>
                <div class="row mb-1 m-2">
                    <label class="col-4 mt-2 mogo-label text-start mogo-bold"  for="order-number-input">Order Number:</label>
                    <div class="col-8">
                        <input id="order-number-input" type="text" class="form-control required" formControlName="orderNumber"  placeholder="Order Number" />
                    </div>
                </div>
                <div class="row mb-1 m-2">
                    <label class="col-4 mt-2 mogo-label text-start mogo-bold" for="temperature-input">Temp Type</label>
                    <div class="col-8">
                        <ng-select id="temperature-type-search" class="mb-1 required" [items]="temperatureTypes" bindLabel="name"
                            bindValue="name" dropdownPosition="bottom" formControlName="temperatureType">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <div class="text-md-start">
                                    {{ item }}
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="row mb-1 m-2">
                    <label class="col-4 mt-2 mogo-label text-start mogo-bold"  for="temperature-input">Temp (°C):</label>
                    <div class="col-8">
                        <input id="temperature-input" type="number" class="form-control" formControlName="temperature"  placeholder="Temperature" />
                    </div>
                </div>
                <div class="row mb-1 m-2">
                    <label class="col-4 mt-2 mogo-label text-start mogo-bold"  for="export-order-input">Export Order:</label>
                    <div class="col-1 mt-1">
                        <input id="export-order-input" type="checkbox" class="" formControlName="exportOrder"   />
                    </div>
                </div>
                @if(formGroup.get('orderDetail')
                    && formGroup.get('orderDetail')!.get('exportOrder')
                    && formGroup.get('orderDetail')!.get('exportOrder')!.value === true){
                        <div class="row mb-1 m-2">
                            <label class="col-4 mt-2 mogo-label text-start mogo-bold" for="request-truck-input">Request Truck:</label>
                            <div class="col-8">
                                <input id="request-truck-input" class="form-control" type="text" formControlName="requestTruck" placeholder="Request Truck"  />
                            </div>
                        </div>
                }

                @if(formGroup.get('orderDetail')
                    && formGroup.get('orderDetail')!.get('exportOrder')
                    && formGroup.get('orderDetail')!.get('exportOrder')!.value === true){
                        <div class="row mb-1 m-2">
                            <label class="col-4 mt-2 mogo-label text-start mogo-bold" for="request-truck-input">Export Certificate Number:</label>
                            <div class="col-8">
                                <input id="export-certificate-number-input" class="form-control" type="text" formControlName="exportCertificateNumber" placeholder="Export Certificate Number" maxlength="30" />
                                @if(formGroup.get('orderDetail')?.get('exportCertificateNumber')?.hasError('maxlength')
                                    && formGroup.get('orderDetail')?.get('exportCertificateNumber')?.touched){
                                    <div class="text-start">
                                        <small class="text-danger">Maximum only 30 characters are allowed</small>
                                    </div>
                                }
                            </div>
                        </div>
                }

            </div>
        </form>
    }
